import BackHeader from './BackHeader';
import { BackHeaderProps, BackHeaderValueProps } from './types';

export type { BackHeaderProps, BackHeaderValueProps };
export default BackHeader;
